"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("../utils/styled"));
const constants_1 = require("../utils/constants");
exports.SectionHeader = styled_1.default("div")(({ theme }) => ({
    fontFamily: theme.font.family.main,
    fontSize: theme.font.size.body,
    fontWeight: theme.font.weight.medium,
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.color.background.lighter,
    color: theme.color.text.dark,
    flex: "0 0",
    // This ensures that the card header text and card controls are placed in opposite corners.
    justifyContent: "space-between",
    height: constants_1.headerHeight,
    padding: `0 ${theme.space.element}px`,
    lineHeight: 1,
}));
//# sourceMappingURL=SectionHeader.js.map